import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  // HttpResponse,
} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { CookieService } from 'angular2-cookie/core';
// import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { tap, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
@Injectable()
export class Interceptor implements HttpInterceptor {
  constructor(public router: Router, private cookie: CookieService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    request = request.clone({
      setHeaders: {
        // 'Content-Type': 'application/json',
        Authorization: 'Bearer_auth=' + this.cookie.get('Bearer_auth'),
      },
    });

    return next.handle(request).pipe(
      catchError((errorResponse: any) => {
        if (errorResponse instanceof HttpErrorResponse) {
          if (errorResponse.status === 401 && errorResponse.error) {
            const error = errorResponse.error.Error;

            if (error === 'Solicitud no autorizada') {
              localStorage.setItem('userToken', 'false');
              this.router.navigate(['/login']);
            }
          }
          // log error
        }
        return of(errorResponse);
      })
    );
  }
}
